import React, { useMemo } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { FaAndroid } from "react-icons/fa";
import ReactModal from "../Modal/Modal";
import { successNotify, errorNotify } from "../../Utils/toast";
import { APK_FILENAME, APP_VERSION } from "../../Constants/androidApp";

const AndroidAppDownloadModal = ({ open, setOpen }) => {
  const apkUrl = useMemo(() => {
    const base = `${window.location.origin}${process.env.PUBLIC_URL || ""}`;
    return `${base}/${encodeURIComponent(APK_FILENAME)}`;
  }, []);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(apkUrl);
      successNotify("Download link copied to clipboard");
    } catch {
      errorNotify("Failed to copy link. Please copy it manually.");
    }
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = apkUrl;
    link.download = APK_FILENAME;
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setOpen(false);
  };

  return (
    <ReactModal
      open={open}
      setOpen={setOpen}
      title="Download Android App"
      subtitle={APP_VERSION}
      size={520}
    >
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <FaAndroid size={48} color="#3DDC84" />
        <Typography sx={{ mt: 2, color: "#394767", fontSize: "15px" }}>
          Get the DH HRM mobile app on your Android device.
        </Typography>
      </Box>

      <Typography sx={{ mb: 1, color: "#394767", fontSize: "14px", fontWeight: 500 }}>
        Download link
      </Typography>
      <TextField
        fullWidth
        size="small"
        value={apkUrl}
        InputProps={{ readOnly: true }}
        sx={{ mb: 3 }}
      />

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5 }}>
        <Button
          variant="outlined"
          onClick={handleCopyLink}
          sx={{
            textTransform: "none",
            borderColor: "#0097D9",
            color: "#0097D9",
            "&:hover": { borderColor: "#007bb5", backgroundColor: "#f3f8fe" },
          }}
        >
          Copy download link
        </Button>
        <Button
          variant="contained"
          onClick={handleDownload}
          sx={{
            textTransform: "none",
            backgroundColor: "#0097D9",
            "&:hover": { backgroundColor: "#007bb5" },
          }}
        >
          Download APK
        </Button>
      </Box>
    </ReactModal>
  );
};

export default AndroidAppDownloadModal;
